(function () {
  'use strict';

  // The <script> tag that loads this file lives inside the section's own
  // markup, so Shopify's theme editor re-executes this entire script on
  // every block/setting edit (it re-renders the section and replays any
  // <script> tags found in the new HTML). Without this registry, each edit
  // would attach a fresh set of document/window-level listeners on top of
  // the previous ones (which reference now-detached DOM), compounding into
  // a listener leak that made the editor progressively slower and, in
  // testing, unresponsive after a handful of edits. GLOBAL tracks one live
  // instance per section id so a re-init can tear down its predecessor
  // first.
  var GLOBAL_KEY = '__tgExpertsCarouselGlobal';

  function getGlobal() {
    if (!window[GLOBAL_KEY]) {
      window[GLOBAL_KEY] = { instances: {}, globalListenersBound: false };
    }
    return window[GLOBAL_KEY];
  }

  function initExpertsCarousel(root) {
    var sectionId = root.getAttribute('data-section-id') || '';
    var global = getGlobal();

    var previous = global.instances[sectionId];
    var preferredBlockId = previous ? previous.lastActiveBlockId : null;
    if (previous) previous.destroy();

    var viewport = root.querySelector('[data-tg-ec-viewport]');
    var track = root.querySelector('[data-tg-ec-track]');
    var prevBtn = root.querySelector('[data-tg-ec-prev]');
    var nextBtn = root.querySelector('[data-tg-ec-next]');
    if (!viewport || !track) return;

    // Self-healing guard: initExpertsCarousel can end up called more than
    // once on the very same physical DOM before a fresh section re-render
    // replaces it (e.g. the re-executed <script> tag's own initAll() call
    // and the shopify:section:load dispatch both firing for one edit). If a
    // prior call already inserted clones here, strip them first so realItems
    // below always reflects just the Liquid-rendered originals — otherwise a
    // second call clones an already-cloned track and the node count balloons
    // (33 -> 99) on a single edit.
    track.querySelectorAll('[data-tg-ec-clone]').forEach(function (el) {
      el.remove();
    });

    var realItems = Array.prototype.slice.call(track.querySelectorAll('[data-tg-ec-item]'));
    var count = realItems.length;
    if (!count) return;

    function stripEditorAttributes(el) {
      el.removeAttribute('id');
      el.removeAttribute('data-shopify-editor-block');
      el.removeAttribute('data-shopify-editor-section');
    }

    function cloneSet() {
      return realItems.map(function (item) {
        var clone = item.cloneNode(true);
        stripEditorAttributes(clone);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-tg-ec-clone', 'true');
        clone.querySelectorAll('[id]').forEach(stripEditorAttributes);
        clone.querySelectorAll('a, button, input, select, textarea').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        return clone;
      });
    }

    // Duplicate the full set before and after the real items so wrapping
    // past either end is a short hop onto a visual duplicate, rather than a
    // long scroll back across the whole track.
    var beforeClones = count > 1 ? cloneSet() : [];
    var afterClones = count > 1 ? cloneSet() : [];

    if (beforeClones.length) {
      var beforeFrag = document.createDocumentFragment();
      beforeClones.forEach(function (clone) {
        beforeFrag.appendChild(clone);
      });
      track.insertBefore(beforeFrag, track.firstChild);
    }
    if (afterClones.length) {
      afterClones.forEach(function (clone) {
        track.appendChild(clone);
      });
    }

    var items = beforeClones.concat(realItems, afterClones);
    var loopEnabled = beforeClones.length > 0 && afterClones.length > 0;
    var realStart = beforeClones.length;
    var realEnd = realStart + count - 1;

    var isDragging = false;
    var dragStartX = 0;
    var dragStartScroll = 0;
    var dragMoved = false;
    var programmaticScroll = false;
    var programmaticScrollTimeout = null;
    var settleTimeout = null;
    var destroyed = false;

    var instance = {
      lastActiveBlockId: preferredBlockId,
      destroy: function () {
        if (destroyed) return;
        destroyed = true;
        clearTimeout(settleTimeout);
        clearTimeout(programmaticScrollTimeout);
        viewport.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', requestUpdate);
        document.removeEventListener('keydown', onKeydown);
      },
    };
    global.instances[sectionId] = instance;

    function setActiveItem(item) {
      var activeIdx = items.indexOf(item);
      items.forEach(function (candidate, idx) {
        candidate.classList.toggle('is-active', idx === activeIdx);
        candidate.classList.toggle('is-prev', idx === activeIdx - 1);
        candidate.classList.toggle('is-next', idx === activeIdx + 1);
      });
      if (item) {
        var blockId = item.getAttribute('data-tg-ec-block-id');
        if (blockId) instance.lastActiveBlockId = blockId;
      }
    }

    function getActiveIndex() {
      var activeItem = items.filter(function (item) {
        return item.classList.contains('is-active');
      })[0];
      var index = items.indexOf(activeItem);
      return index === -1 ? realStart : index;
    }

    // Silently swap the active item from a cloned duplicate onto its real
    // counterpart (or vice versa) with no animation and no visible shift, so
    // the carousel can keep advancing indefinitely without ever running out
    // of items to scroll to.
    function silentSwap(toItem) {
      programmaticScroll = true;
      var viewportRect = viewport.getBoundingClientRect();
      items.forEach(function (item) {
        item.style.transitionDuration = '0s';
      });
      setActiveItem(toItem);
      void track.offsetWidth; // Force layout so the width change above applies before we measure.
      var toRect = toItem.getBoundingClientRect();
      var delta = (toRect.left + toRect.width / 2) - (viewportRect.left + viewportRect.width / 2);
      viewport.scrollLeft = viewport.scrollLeft + delta;
      void track.offsetWidth;
      items.forEach(function (item) {
        item.style.transitionDuration = '';
      });
      programmaticScroll = false;
    }

    function maybeWrap() {
      if (!loopEnabled) return;
      var index = getActiveIndex();
      if (index < realStart) {
        silentSwap(items[index + count]);
      } else if (index > realEnd) {
        silentSwap(items[index - count]);
      }
    }

    function updateActiveItem() {
      var viewportRect = viewport.getBoundingClientRect();
      var viewportCenter = viewportRect.left + viewportRect.width / 2;

      var closestItem = null;
      var closestDistance = Infinity;

      items.forEach(function (item) {
        var rect = item.getBoundingClientRect();
        var itemCenter = rect.left + rect.width / 2;
        var distance = Math.abs(itemCenter - viewportCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestItem = item;
        }
      });

      setActiveItem(closestItem);
      maybeWrap();
    }

    function requestUpdate() {
      if (destroyed) return;
      // Skip while a button-driven scroll is animating — the width/height
      // transition on the active item shifts scroll geometry mid-flight,
      // which would otherwise re-trigger this and flip is-active back and
      // forth, causing two bios to render active (and overlap) at once.
      if (programmaticScroll) return;
      // Debounce until scrolling actually stops rather than recalculating on
      // every scroll frame. Recalculating mid-scroll flips is-active on an
      // item, which starts its own width/height transition — that shifts
      // scroll geometry under the still-firing listener, so it can flip to a
      // neighbor and back repeatedly (most visible right as it settles at
      // the start/end of the track).
      clearTimeout(settleTimeout);
      settleTimeout = setTimeout(updateActiveItem, 120);
    }

    viewport.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    function scrollToItem(item) {
      if (!item || destroyed) return;
      setActiveItem(item);
      programmaticScroll = true;
      clearTimeout(programmaticScrollTimeout);
      var viewportRect = viewport.getBoundingClientRect();
      var itemRect = item.getBoundingClientRect();
      var currentScroll = viewport.scrollLeft;
      var delta = (itemRect.left + itemRect.width / 2) - (viewportRect.left + viewportRect.width / 2);
      viewport.scrollTo({ left: currentScroll + delta, behavior: 'smooth' });
      // Matches the CSS transition on portrait/bio, plus a buffer for the
      // smooth-scroll to finish settling.
      programmaticScrollTimeout = setTimeout(function () {
        programmaticScroll = false;
        maybeWrap();
      }, 650);
    }

    function goPrev() {
      var index = getActiveIndex();
      var target = items[Math.max(0, index - 1)];
      scrollToItem(target);
    }

    function goNext() {
      var index = getActiveIndex();
      var target = items[Math.min(items.length - 1, index + 1)];
      scrollToItem(target);
    }

    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    if (nextBtn) nextBtn.addEventListener('click', goNext);

    // Keyboard support: left/right arrows step the carousel while it's in
    // view, matching the prev/next buttons.
    function isInViewport() {
      var rect = root.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0 && rect.left < window.innerWidth && rect.right > 0;
    }

    function onKeydown(event) {
      if (destroyed) return;
      if (!isInViewport()) return;
      var active = document.activeElement;
      if (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) return;
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goNext();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goPrev();
      }
    }

    document.addEventListener('keydown', onKeydown);

    // Pointer drag / swipe support.
    //
    // setPointerCapture is deliberately NOT called on pointerdown. Chromium
    // redirects the compatibility "click" event's target to the capturing
    // element once a pointer is captured, even if the press/release both
    // land on an inner element (e.g. a CTA <a>) with no movement between
    // them — that silently killed clicks on every card's CTA link and
    // portrait, since every pointerdown here captured to viewport. Capture
    // is instead engaged lazily, the first time real movement confirms an
    // actual drag, so a plain tap keeps native click semantics.
    viewport.addEventListener('pointerdown', function (event) {
      isDragging = true;
      dragMoved = false;
      dragStartX = event.clientX;
      dragStartScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!isDragging) return;
      var delta = event.clientX - dragStartX;
      if (Math.abs(delta) > 3) {
        if (!dragMoved) {
          try {
            viewport.setPointerCapture(event.pointerId);
          } catch (e) {
            // Ignore — pointer may already be gone.
          }
        }
        dragMoved = true;
      }
      viewport.scrollLeft = dragStartScroll - delta;
      requestUpdate();
    });

    function endDrag(event) {
      if (!isDragging) return;
      isDragging = false;
      viewport.classList.remove('is-dragging');
      try {
        viewport.releasePointerCapture(event.pointerId);
      } catch (e) {
        // Ignore — pointer may have already been released.
      }
      requestUpdate();
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('pointerleave', function () {
      if (isDragging) isDragging = false;
      viewport.classList.remove('is-dragging');
    });

    // Prevent click-through on portrait/CTA right after a drag.
    track.addEventListener(
      'click',
      function (event) {
        if (dragMoved) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    function findItemByBlockId(blockId) {
      if (!blockId) return null;
      for (var i = realStart; i <= realEnd; i++) {
        if (items[i].getAttribute('data-tg-ec-block-id') === blockId) return items[i];
      }
      return null;
    }

    // Center the initial slide once images have laid out. Jump straight
    // there with no animation — with the cloned sets in place, the starting
    // scroll position is far from 0, and animating that on page load would
    // sweep visibly across the duplicated items. Default to the FIRST block
    // in the editor's list (realStart) so reordering blocks in the theme
    // editor is the one, obvious way to control which expert opens
    // centered — not an index-math coincidence. When this init is actually
    // a re-render triggered by editing a block (see the registry above),
    // re-center on whichever block was active before instead of always
    // resetting to the first block — otherwise every edit visibly kicks the
    // carousel back to its default position.
    window.requestAnimationFrame(function () {
      if (destroyed) return;
      var startItem = findItemByBlockId(preferredBlockId) || items[realStart];
      if (startItem) {
        programmaticScroll = true;
        setActiveItem(startItem);
        var viewportRect = viewport.getBoundingClientRect();
        var itemRect = startItem.getBoundingClientRect();
        var delta = (itemRect.left + itemRect.width / 2) - (viewportRect.left + viewportRect.width / 2);
        viewport.scrollLeft = viewport.scrollLeft + delta;
        programmaticScroll = false;
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-tg-experts-carousel]').forEach(initExpertsCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // The <script> tag that loads this file lives inside the section's own
  // markup, so Shopify's theme editor re-executes this ENTIRE script on
  // every block/setting edit — including this top-level code. Without this
  // guard, these two document-level listeners would be re-registered on
  // every edit and never removed: after N edits there would be N of them,
  // and the next reload would fire initExpertsCarousel N times in the same
  // tick, each call re-cloning whatever the previous call just inserted.
  // That compounding blowup (not just the per-instance listeners guarded
  // above) was the real cause of the editor becoming unusable after a
  // handful of edits, so these must only ever be attached once per page.
  var globalState = getGlobal();
  if (!globalState.globalListenersBound) {
    globalState.globalListenersBound = true;

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-tg-experts-carousel]');
      if (root) initExpertsCarousel(root);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target && event.target.querySelector && event.target.querySelector('[data-tg-experts-carousel]');
      var sectionId = root && root.getAttribute('data-section-id');
      var g = getGlobal();
      if (sectionId && g.instances[sectionId]) {
        g.instances[sectionId].destroy();
        delete g.instances[sectionId];
      }
    });
  }
})();
